<script>
import Vue from "vue";
import { router } from "../router";
import { Usuario } from "../class/usuario";
export default {
    beforeMount() {
        if (this.$route.params.token) {
            this.$store.commit("login", {});

            Vue.http.headers.common["Authorization"] =
                "JWT " + this.$route.params.token;

            Usuario.authToken(this.$route.params.token)
                .then(data => {
                    window.localStorage.setItem(
                        "token",
                        this.$route.params.token
                    );
                    this.$store.commit("login", data);
                    return router.push({ path: "/" });
                })
                .catch(() => router.push({ path: "/login" }));
        } else {
            router.push({ path: "/login" });
        }
    }
};
</script>
